import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: false,
    },
    themes: {
      light: {
        primary: '#00A0DF',
        secondary: '#092E6F',
        disabled: '#424242',
        accent: '#82B1FF',
        complementary: 'df3f00',
        complementary2: '#002E6D',
        error: '#df0000',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        bordesSencha: '#d1d0d0',
        azulSencha: '#3892d4',
        grisSelected: '#E4E4E4',
      },
      dark: {
        primary: '#00A0DF',
        secondary: '#092E6F',
        disabled: '#424242',
        accent: '#82B1FF',
        complementary: 'df3f00',
        complementary2: '#002E6D',
        error: '#df0000',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        bordesSencha: '#d1d0d0',
        azulSencha: '#3892d4',
        grisSelected: '#E4E4E4',
      }
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: 'mdi' || 'fa', // default - only for display purposes
  },
});